<template>
  <div class="view contentBody">
    <div class="title">企业动态</div>
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item" :pageStatus.sync="pageStatus" @refreshFn="refreshFn"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import listPannel from "./listPannel.vue";
  import columnPannel from "./columnPannel.vue";
  import commentsPannel from "./commentsPannel.vue";
  import setPannel from "./setPannel.vue";
  import draftBoxPannel from "./draftBoxPannel.vue";
  let tabBox = {
    '动态管理': {property: 'listPannel'},
    '草稿箱': {property: 'draftBoxPannel'},
    // '评论管理': {property: 'commentsPannel'},
    '栏目管理': {property: 'columnPannel'},
    '动态设置': {property: 'setPannel'}
  }

  export default {
    name: "moments",
    components: {
      listPannel,
      columnPannel,
      commentsPannel,
      setPannel,
      draftBoxPannel
    },
    data() {
      return {
        pageStatus: false,
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName: ""
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "listPannel";
      },
      tabCurrentFn(index){
        this.meaulistTab.firstTab = index
      },
      refreshFn(){
        this.pageStatus = !this.pageStatus
      }
    }
  };
</script>
